import { Component, ViewEncapsulation, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';

/**
 * 使用画像リストを管理するクラス
 *
 * @export KYMW1407UseImageComponent
 * @class KYMW1407UseImageComponent
 */
@Component({
  selector: 'app-kymw1407-use-image',
  templateUrl: 'kymw1407-use-image.component.html',
  styleUrls: ['kymw1407-use-image.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1407UseImageComponent {
  @ViewChild('hli_UseImageList', { static: true }) hli_UseImageList: ElementRef;
  @ViewChild('useImageGroups', { static: true }) useImageGroups: ElementRef;

  @Input() useImageList: Array<any> = null;

  @Output() eventUseImageList_ITEMCLICK: EventEmitter<any> = new EventEmitter;

  /**
   *Creates an instance of KYMW1407UseImageComponent.
   * @memberof KYMW1407UseImageComponent
   */
  constructor(
  ) {
  }
}
